import React from 'react';
import {Option} from '../../../../hooks/dropdown/useSearch';

export type AvailableStatusesState = {
    statuses: Option[];
    setStatuses: (statuses: Option[]) => void;
};

export const AvailableStatusesContext = React.createContext<AvailableStatusesState>({
    statuses: [],
    setStatuses: () => {}
});
